import { useState } from "react";
import close from "../../vendor/close.svg";
import "./Footer.css";

function Footer({ sendedObjects, getNotSendCount }) {
  const [isSendedListOpen, setSendedListOpen] = useState(false);
  return (
    <>
      <footer className="Footer">
        <div className="Footer_content">
          <h2>
            <span className="Footer-text_black">Всего откликов:</span>&nbsp;
            <span className="Footer-text_orange">
              {getNotSendCount() + sendedObjects.length}
            </span>
          </h2>
          <h2
            onClick={() => {setSendedListOpen(true)}}
            className="Footer-text_orange"
          >
            {`Отправлено: ${sendedObjects.length}`}
          </h2>
          <h2 className="Footer-text_black">{`Осталось: ${getNotSendCount()}`}</h2>
        </div>
      </footer>
      {isSendedListOpen ? (
        <div className="overlay">
          <div className="table-container">
            <div className="table-wrapper">
              <table className="table table-footer">
                <thead
                  id="shifted"
                  className="table-header table-footer-header"
                >
                  <tr className="table-header-row table-footer-header-row">
                    <th>
                      <span className="table-header-cell">№</span>
                    </th>
                    <th>
                      <span className="table-header-cell">ИНК</span>
                    </th>
                    <th>
                      <span className="table-header-cell">Вакансия</span>
                    </th>
                    <th>
                      <span className="table-header-cell">ФИО</span>
                    </th>
                    <th>
                      <span className="table-header-cell">Телефон</span>
                    </th>
                    <th id="classic">
                      <span className="table-header-cell">Город</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sendedObjects.map((i, ind) => (
                    <tr key={ind}>
                      <td className="table-footer-cell">{`${ind + 1}.`}</td>
                      <td className="table-footer-cell">{i.ink}</td>
                      <td className="table-footer-cell">{i.vacancy}</td>
                      <td className="table-footer-cell">{i.name}</td>
                      <td className="table-footer-cell">{i.phone}</td>
                      <td className="table-footer-cell">
                        {i.city && typeof i.city === "string" ? i.city : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button
              className="table-footer-close"
              onClick={() => {
                setSendedListOpen(false);
              }}
            >
              Скрыть&nbsp;
              <img src={close} alt="закрыть" />
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default Footer;
